import { connect } from 'react-redux';

import { RootState } from '../../../../reducers';
import FileInput from '../../FileInput/FileInput';
import UploadedFilesStatus from '../../FileUpload/UploadedFilesStatus';
import MissingRequiredDocWarning from '../../MissingRequiredDocWarning/MissingRequiredDocWarning';
import { useDocPresentStatus } from '../../MissingRequiredDocWarning/MissingRequiredDocWarning.hook';
import { documentTypes } from '../../TradingHistory.helpers';
import thstyles from '../../TradingHistory.module.css';
import styles from '../OptionalStatement.module.css';

const mapStateToProps = (state: RootState) => {
    return {
        missingDocs: state?.tradingHistory?.missing
    };
};

const AgedDebtorReport = ({
    isOptional,
    missingDocs
}: {
    isOptional: boolean;
    missingDocs: [];
}) => {
    const isAgedDebtorReportMissing = useDocPresentStatus(
        missingDocs,
        'aged_debtor_report'
    );

    return (
        <>
            <div className={thstyles.headerSection}>
                <h3 className={thstyles.title}>Aged debtor report</h3>
                {isAgedDebtorReportMissing && (
                    <MissingRequiredDocWarning dataTestId="aged-debtor-report-warning" />
                )}
            </div>
            <div
                className={styles.CurrentManagementSection}
                data-testid="adr-uploads">
                <div className={styles.descriptionContainer}>
                    <p>
                        This should be a list of invoices you have issued but
                        are yet to be paid, and ideally grouped by the number of
                        days outstanding e.g. (30, 60, 90+ days).{' '}
                        <a
                            href="https://gocardless.com/guides/posts/aged-debtors-report/"
                            target="_blank"
                            rel="noopener noreferrer">
                            Learn more
                        </a>
                    </p>
                </div>
                <FileInput
                    documentType={documentTypes.aged_debtor_report}
                    buttonText="Upload report"
                    isOptional={isOptional}
                />
            </div>
            <UploadedFilesStatus
                documentType={documentTypes.aged_debtor_report}
            />
        </>
    );
};

export default connect(mapStateToProps)(AgedDebtorReport);
